import { Box, Paper, Table, TableContainer, TableBody } from "@mui/material";
import React from "react";
import TableList from "./TableList";
import EnhancedTableHead from "./TableHead";

export interface Data {
  id: number;
  complaintName: string;
  activeStatus: any;
  complaintsDescription: string;
  createdAt: string;
  updatedAt: string;
}

type Order = "asc" | "desc";

const DashTable = (props:any) => {
  const {
    activeIndex,
    setUpdateData,
    setShow,
    carepackageData = { data: [] },
    assignmenthistoryData = { data: [] },
    refetch,
  } = props;
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("createdAt");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  return (
    <div className="Enhance-table">
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer className="custom-tablebody">
            <Table sx={{ minWidth: 800 }} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                activeIndex={activeIndex}
              />

              <TableBody>
                <TableList
                  setShow={setShow}
                  refetch={refetch}
                  activeIndex={activeIndex}
                  carepackageData={carepackageData}
                  assignmenthistoryData={assignmenthistoryData}
                  setUpdateData={setUpdateData}
                />
              </TableBody>
            </Table>
            {/* {isLoading && (
              <div className="d-flex justify-content-center">
                <TableLoad />
              </div>
            )}
            {customer?.data?.length === 0 && (
              <div className="d-flex justify-content-center">
                <small className="m-3">No results found!</small>
              </div>
            )} */}
          </TableContainer>
        </Paper>
      </Box>
    </div>
  );
};

export default DashTable;